import { Injectable } from "@angular/core";
import {
  BehaviorSubject,
  interval,
  Observable,
  Subject,
  Subscription,
  tap,
} from "rxjs";
import { DataService } from "../../../shared/services/data.service";
import { Result } from "../../../shared/model/response.model";
import { StorageService } from "../../../shared/services/storage.service";

@Injectable({
  providedIn: "root",
})
export class OutlookService {
  private countdown$ = new BehaviorSubject<number>(0);
  private finish$ = new Subject<void>();
  countdownObs = this.countdown$.asObservable();
  finishObs = this.finish$.asObservable();
  private timerSub?: Subscription;
  outlookData = new BehaviorSubject<any>(null);
  public callLoginRefresh$ = new Subject<void>();
  public triggerRefresh$ = new Subject<void>();
  constructor(public service: DataService,public storageService : StorageService) {
    this.restoreTimer()
  }
  startTimer(seconds: number) {
    if (this.timerSub) {
      this.timerSub.unsubscribe();
    }

    this.countdown$.next(seconds);

    this.timerSub = interval(1000).subscribe(() => {
      const current = this.countdown$.getValue();

      if (current > 1) {
        this.countdown$.next(current - 1);
      } else {
        this.countdown$.next(0);
        this.finish$.next(); // 👈 timer finished
         this.triggerRefresh$.next(); 
        this.timerSub?.unsubscribe();
      }
    });
  }
  restoreTimer() {
  const expiry = this.storageService.retrieve('session_expiry');
  if (expiry) {
    const remaining = Math.floor((+expiry - Date.now()) / 1000);

    if (remaining > 0) {
      this.startTimer(remaining);
    } else {
      this.finish$.next(); // timer already expired
      this.countdown$.next(0);
    }
  }
}
  getAuthUrl(): Observable<Result> {
    let url = "app/outlookMail/auth/url";
    return this.service.get(url, true).pipe<Result>(
      tap((response: any) => {
        return response;
      })
    );
  }

  authCallback(data: any): Observable<Result> {
    let url = `app/outlookMail/auth/callback?authCode=${data?.authCode}&userId=${data?.userId}`;
    return this.service.get(url, true).pipe<Result>(
      tap((response: any) => {
        return response;
      })
    );
  }

  getAllToken(userId: any): Observable<Result> {
    let url = `app/outlookMail/tokens?userId=${userId}`;
    return this.service.get(url, true).pipe<Result>(
      tap((response: any) => {
        return response;
      })
    );
  }

  getRefreshToken(refreshToken: any, userId: any): Observable<Result> {
    let url = `app/outlookMail/tokens/refresh?refreshToken=${refreshToken}&userId=${userId}`;
    return this.service.get(url, true).pipe<Result>(
      tap((response: any) => {
        return response;
      })
    );
  }

  getProfile(accessToken: any): Observable<Result> {
    let url = `app/outlookMail/me/profile?accessToken=${accessToken}`;
    return this.service.get(url, true).pipe<Result>(
      tap((response: any) => {
        return response;
      })
    );
  }

  getInboxData(data: any) {
    let url = `app/outlookMail/me/mail/inbox`;
    return this.service.post(url, data, true).pipe<Result>(
      tap((response: any) => {
        return response;
      })
    );
  }
  getSentData(data: any) {
    let url = `app/outlookMail/me/mail/sent`;
    return this.service.post(url, data, true).pipe<Result>(
      tap((response: any) => {
        return response;
      })
    );
  }
  composeMail(data: any) {
    let url = `app/outlookMail/me/mail/send`;
    return this.service.post(url, data, true).pipe<Result>(
      tap((response: any) => {
        return response;
      })
    );
  }
  getTrashData(data: any) {
    let url = `app/outlookMail/me/mail/trash`;
    return this.service.post(url, data, true).pipe<Result>(
      tap((response: any) => {
        return response;
      })
    );
  }

  outlookDisconnect(data: any) {
    let url = `app/outlookMail/me/logout?token=${data?.token}&userId=${data?.userId}`;
    return this.service.get(url, true).pipe<Result>(
      tap((response: any) => {
        return response;
      })
    );
  }
  statusUpdate(data: any) {
    let url = `app/outlookMail/me/mail/statusupdate`;
    return this.service.post(url, data, true).pipe<Result>(
      tap((response: any) => {
        return response;
      })
    );
  }
  bulkdelete(data: any) {
    let url = `app/outlookMail/me/mail/bulkdelete`;
    return this.service.post(url, data, true).pipe<Result>(
      tap((response: any) => {
        return response;
      })
    );
  }
}
